import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import SecondaryNavAbstract from '../common/SecondaryNavAbstract';
import SecondaryNavItem from '../common/SecondaryNavItem';
import SecondarySubNavAccordion from './SecondarySubNavAccordion';

/**
 * A secondary menu with accordion buttons.
 */
var SecondaryNavAccordion = /*#__PURE__*/function (_SecondaryNavAbstract) {
  _inherits(SecondaryNavAccordion, _SecondaryNavAbstract);
  var _super = _createSuper(SecondaryNavAccordion);
  /**
   * Initialize.
   *
   * @param {HTMLElement} elem  The outermost wrapper for the Navigation.
   * @param {Object} options    An object of metadata.
   */
  function SecondaryNavAccordion(elem) {
    var _this;
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, SecondaryNavAccordion);
    // Let super do what super does.
    _this = _super.call(this, elem, options);

    // Ok do the creation.
    _this.createSubNavItems();

    // Expand the active path.
    _this.activePath.expandActivePath();
    return _this;
  }

  /**
   * Add the additional state handling after the abstract option has run.
   *
   * @param  {HTMLElement} item The HTMLElement being acted upon.
   */
  _createClass(SecondaryNavAccordion, [{
    key: "expandActivePathItem",
    value: function expandActivePathItem(item) {
      item.firstElementChild.setAttribute('aria-expanded', 'true');
    }

    /**
     * Function for creating a new nested navigation item.
     *
     * @param  {HTMLElement} item     The HTMLElement to attach a new subnav to.
     * @param  {Integer} depth        The level of nesting. (starts at 1)
     * @param  {Object|Mixed} parent  The parent subnav instance.
     *
     * @return {SecondarySubNavAccordion} A brand new instance.
     */
  }, {
    key: "newParentItem",
    value: function newParentItem(item, depth, parent) {
      var opts = this.options;
      opts.depth = depth;
      var nav = new SecondarySubNavAccordion(item, this, parent, opts);
      this.subNavItems.push(nav);
      return nav;
    }

    /**
     * Function for creating a new single tier navigation item.
     *
     * @param  {HTMLElement} item     The HTMLElement to attach a new subnav to.
     * @param  {Integer} depth        The level of nesting. (starts at 1)
     * @param  {Object|Mixed} parent  The parent subnav instance.
     *
     * @return {SecondaryNavItem} A brand new instance.
     */
  }, {
    key: "newNavItem",
    value: function newNavItem(item, depth, parent) {
      var opts = this.options;
      opts.depth = depth;
      var nav = new SecondaryNavItem(item, this, parent, opts);
      this.navItems.push(nav);
      return nav;
    }
  }]);
  return SecondaryNavAccordion;
}(SecondaryNavAbstract);
export { SecondaryNavAccordion as default };